class Announcement extends HTMLElement {
  static NONE = 'none';
  static SESSION = 'session';
  static LOCAL = 'local';

  closeButton; selectors; mode; visible; text;

  constructor(){
    super();
    this.init();
  } 

  init = () => {
    this.selectors = {
      close: '[data-announcement-close]',
      text: '[data-announcement-text]'
    }
    this.closeButton = this.querySelector(this.selectors.close);
    if(this.closeButton != undefined){
      this.mode = this.closeButton.dataset.announcementClose;
      this.closeButton.addEventListener('click', this.close);
    }
    else
      this.mode = Announcement.NONE;

    if(this.querySelector(this.selectors.text) != undefined)
      this.text = this.querySelector(this.selectors.text).innerText;

    this.checkVisible();
  }

  checkVisible = () => {
    if(this.mode == Announcement.LOCAL){
      this.visible = localStorage.getItem('announcement') != this.text;
    } else if(this.mode == Announcement.SESSION){
      this.visible = sessionStorage.getItem('announcement') == undefined;
    } else {
      this.visible = true;
    }
    if(this.visible){
      this.classList.remove('d-none');
      this.classList.add('d-flex');
    }
  }

  close = () => {
    if(this.mode == Announcement.LOCAL){
      localStorage.setItem('announcement', this.text);
    } else if(this.mode == Announcement.SESSION){
      sessionStorage.setItem('announcement', this.text);
    }
    this.classList.add('d-none');
  }
}


if (!window.customElements.get("announcement-bar")) {
  window.customElements.define("announcement-bar", Announcement);
}